import { Component, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AppRoutingModule } from './app-routing.module';
import { AuthService } from './shared/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertmessageService } from './shared/alertmessage.service';
import { TimeoutComponent } from './timeout/timeout.component';
import { AppService } from './app.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'DormantAccounts';
  modules;
  error: any;
  showHomeHeader: boolean = true;
  stickHomeHeader: boolean = false;
  routeSubscription: Subscription;
  deviceInfo: any;
  browserver: number;
  browsername: string;
  browserWarningOpen: boolean = false;
  IEbrowserWarningOpen: boolean = false;

  
  constructor(
    public location: Location,
    public router: Router,
    public renderer: Renderer2,

    private _deviceService: DeviceDetectorService ,
    //public navService: NavService
    private idle: Idle, 
    private keepalive: Keepalive,
    private appService:AppService,
    public authService:AuthService,
    private modalService: BsModalService,
    public alert:AlertmessageService
){
  let obj=new TimeoutComponent(idle, keepalive, appService, authService, modalService, alert, router);

}
  ngOnInit() {
    console.log("app component");
    
      this.routeSubscription = this.router.events
         // .filter(event => event instanceof NavigationEnd)
          .subscribe(event => {
              /*
              the homepage header/footer only really seem to apply to potential clients.  this hides them on any 'admin' related route- we can also use this to swap it out for an 'admin-related' header if necessary
              */
              //this.showHomeHeader = !event['url'].includes('admin');
              this.stickHomeHeader = event['url'] !== '/';
          });
  }

  ngOnDestroy() {
      if (this.routeSubscription) { this.routeSubscription.unsubscribe(); }
  }
  
}
